import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { generateColumns } from "./columns";
import DataGrid from "react-data-grid";
export const ExampleTable = ({ fields }) => {
    const columns = useMemo(() => generateColumns(fields), [fields]);
    return _jsx(DataGrid, { className: "rdg-light", columns: columns, rows: [] });
};
